import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"

import { cn } from "@/lib/utils"

// The check and the indeterminate dash are stroked paths normalised to
// pathLength=1, so a stroke-dashoffset 1 → 0 keyframe draws them in when
// the indicator mounts (i.e. on check). Explicit size/color classes keep
// a parent's generic `svg` rule (CommandItem, Button) from restyling them.
const drawnPathClass =
  "[stroke-dasharray:1] animate-check-draw motion-reduce:animate-none"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "peer border-input bg-background hover:ring-3 ring-primary/20 hover:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary focus-visible:border-ring focus-visible:ring-ring/20 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[min(var(--radius-sm),6px)] border shadow-xs transition-[box-shadow,background-color,border-color] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current"
      >
        <svg
          className="size-2.5 text-current"
          viewBox="0 0 10 10"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          {props.checked === "indeterminate" ? (
            <path d="M2 5h6" pathLength={1} className={drawnPathClass} />
          ) : (
            <path
              d="M1.75 5.25 4.25 7.75 8.5 2.25"
              pathLength={1}
              className={drawnPathClass}
            />
          )}
        </svg>
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
